"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuFormattedDate = void 0;
const getRuFormattedDate = (date) => (typeof date === 'string' ? new Date(date) : date).toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});
exports.getRuFormattedDate = getRuFormattedDate;
